import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

interface LoginLogData {
  id: number;
  userId: number;
  username: string;
  ipAddress: string;
  status: string;
  responseMessage: string | null;
  createdAt: string;
}

interface LoginLogsResponse {
  statusCode: number;
  message: string;
  data: {
    data: LoginLogData[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

interface LoginLogsState {
  loginLogsData: LoginLogsResponse | null;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | null;
}

const loginLogsInitialState: LoginLogsState = {
  loginLogsData: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getLoginLogs: any = createAsyncThunk(
  "loginLogs/getLoginLogs",
  async (payload: { page?: number; limit?: number; userId?: number; username?: string; status?: string; startDate?: string; endDate?: string }, thunkAPI) => {
    try {
      const requestBody = {
        page: payload.page || 1,
        limit: payload.limit || 10,
        ...(payload.userId && { userId: payload.userId }),
        ...(payload.username && { username: payload.username }),
        ...(payload.status && { status: payload.status }),
        ...(payload.startDate && { startDate: payload.startDate }),
        ...(payload.endDate && { endDate: payload.endDate }),
      };

      const response = await Api.post(
        API_URLS.AUTH.LOGIN_LOGS,
        requestBody
      );

      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const resetAll = () => ({
  type: "loginLogs/resetAll",
});

const loginLogsSlice = createSlice({
  name: "loginLogsState",
  initialState: loginLogsInitialState,
  reducers: {
    resetAll: (state) => {
      state.loginLogsData = null;
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Login Logs
      .addCase(getLoginLogs.pending, (state) => {
        state.loading = "pending";
        state.error = null;
        state.action = "list";
      })
      .addCase(getLoginLogs.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.loginLogsData = action.payload;
        state.error = null;
      })
      .addCase(getLoginLogs.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload;
      });
  },
});

export const { resetAll: resetLoginLogsAll } = loginLogsSlice.actions;
export default loginLogsSlice.reducer;
